// extracted by mini-css-extract-plugin
export default {"tile":"HcPuWY","dashboardTile":"v6ymdD"};